import { useCallback } from "react";

import { DeleteOutlineOutlinedIcon } from "icons";

import IconButton from "components/IconButton";
import { MenuItem } from "components/Menu";
import Tooltip from "components/Tooltip";
import { useConfirmationDialog } from "components/useConfirmationDialog";

export interface IDeleteButton {
  onDelete: () => void;
  buttonType?: "menuItem" | "icon";
}

const DeleteButton = ({ onDelete, buttonType = "icon" }: IDeleteButton) => {
  const { show: showConfirmationDialog } = useConfirmationDialog();

  const handleDelete = useCallback(() => {
    showConfirmationDialog({
      onConfirm: onDelete,
      confirmButtonText: "Yes",
      message: "Are you sure you want to delete this table?",
    });
  }, [onDelete, showConfirmationDialog]);

  return buttonType === "icon" ? (
    <Tooltip title="Delete">
      <IconButton onClick={handleDelete}>
        <DeleteOutlineOutlinedIcon />
      </IconButton>
    </Tooltip>
  ) : (
    <MenuItem onClick={handleDelete}>
      <DeleteOutlineOutlinedIcon
        sx={{ marginRight: 1, height: "24px", width: "24px" }}
      />{" "}
      Delete this table
    </MenuItem>
  );
};

export default DeleteButton;
